export default "__VITE_ASSET__Cg659n6U__"